// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"497e8c8f","560":"d64cb420","757":"1911a54e","883":"b62f81ef","908":"6cadf4dc"}[chunkId] + ".chunk.js";
};